import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _flagsInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flags";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { isEmpty, get, includes } from 'lodash';
import { Button } from '@unite-us/ui';
import OverlaySpinner from '../../../common/spinners/OverlaySpinner';
import { createEmailConsent, createSmsConsent, createDocumentConsent, createAudioConsent } from '../../actions';
import { CONSENT_COMPLETED, CONSENT_FORM_HEADER_MESSAGE, CONSENT_OPTIONS, CHOOSE_PREFERRED_LANGUAGE_MESSAGE, DIGITAL_CONSENT_TYPES } from '../../constants';
import { getSubmitConsentText, isUploadConsentType } from '../../utils';
import { arrays } from '@unite-us/client-utils';
import callOrLog from '../../../../constants/callOrLog';
import { CONSENT } from '../../../../constants/eventConstants';
import { LanguageSelector } from '@unite-us/app-components';
import ConsentAppFrame from './ConsentAppFrame';
import ConsentTypeChoices from './ConsentTypeChoices';
import { extractAuthTokenFromAdapter } from '../../../../utils/adapters';

// Style Imports
import '../../stylesheets/informedConsent.scss';
var findPrimaryOrFirst = arrays.findPrimaryOrFirst;
var DEFAULT_SELECTED_CONSENT_CHOICE = CONSENT_OPTIONS.ON_SCREEN_ATTESTATION;
export function RequestOrUploadConsentForm(props) {
  var initialConsentType = props.initialConsentType,
    contact = props.contact,
    employee = props.employee,
    allowSkipConsent = props.allowSkipConsent,
    currentView = props.currentView,
    styles = props.styles,
    adapters = props.adapters,
    flags = _flagsInstanceProperty(props),
    constants = props.constants,
    language = props.language,
    callbacks = props.callbacks;
  var CONSENT_APP_URL = constants.CONSENT_APP_URL;
  var shouldShowTranslationsNewLanguages = flags.shouldShowTranslationsNewLanguages;
  var onLanguageChange = callbacks.onLanguageChange,
    onNavigateAway = callbacks.onNavigateAway,
    onCurrentViewChange = callbacks.onCurrentViewChange,
    onError = callbacks.onError,
    onConsentSent = callbacks.onConsentSent,
    onCommunicationSent = callbacks.onCommunicationSent,
    onTrackEvent = callbacks.onTrackEvent;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isConsentAppLoading = _useState2[0],
    setIsConsentAppLoading = _useState2[1];
  var _useState3 = useState(initialConsentType || DEFAULT_SELECTED_CONSENT_CHOICE),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedConsentType = _useState4[0],
    setSelectedConsentType = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    fileUpload = _useState6[0],
    setFileUpload = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    submitting = _useState8[0],
    setSubmitting = _useState8[1];
  var iframeRef = useRef(null);
  useEffect(function () {
    window.addEventListener('message', onConsentComplete);
    window.addEventListener('message', onProvideAuthToken);
    return function () {
      window.removeEventListener('message', onConsentComplete);
      window.removeEventListener('message', onProvideAuthToken);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (!DIGITAL_CONSENT_TYPES.includes(selectedConsentType)) {
      onLanguageChange('en');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConsentType]);
  var consentAppSubmissionMethod = currentView === 'consentAppAttestation' ? 'attestation' : '';
  var consentAppUrl = "".concat(CONSENT_APP_URL) + "?person_id=".concat(contact.id) + "&first_name=".concat(contact.first_name) + "&last_name=".concat(contact.last_name) + "&employee_id=".concat(employee.id) + "&employee_fullname=".concat(employee.full_name) + "&submission_method=".concat(consentAppSubmissionMethod) + "&form-only&language=".concat(language);
  var isConsentAppShown = ['consentApp', 'consentAppAttestation'].includes(currentView);
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var consentValue, consentParams, consentActions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSubmitting(true);
            consentValue = isUploadConsentType(selectedConsentType) ? fileUpload : values[selectedConsentType];
            consentParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              contactId: contact.id,
              employeeId: employee.id,
              adapter: adapters.coreApi
            }, selectedConsentType === CONSENT_OPTIONS.EMAIL_ADDRESS ? {
              emailAddress: consentValue
            } : null), selectedConsentType === CONSENT_OPTIONS.PHONE_NUMBER ? {
              phoneNumber: consentValue
            } : null), isUploadConsentType(selectedConsentType) ? {
              file: consentValue === null || consentValue === void 0 ? void 0 : consentValue.file
            } : null), {}, {
              language: language
            });
            consentActions = {
              audio: createAudioConsent,
              document: createDocumentConsent,
              email_address: createEmailConsent,
              phone_number: createSmsConsent
            };
            _context.prev = 4;
            if (!isUploadConsentType(selectedConsentType)) {
              _context.next = 9;
              break;
            }
            if (!isEmpty(consentValue)) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", onError('Upload document is required'));
          case 8:
            callOrLog(function () {
              return onTrackEvent(CONSENT.upload, {
                consent_type: selectedConsentType,
                contact_id: contact.id
              });
            });
          case 9:
            _context.next = 11;
            return consentActions[selectedConsentType](consentParams);
          case 11:
            if (isUploadConsentType(selectedConsentType)) {
              onConsentSent();
            } else {
              onCommunicationSent();
            }
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            onError(_context.t0);
          case 17:
            _context.prev = 17;
            setSubmitting(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 14, 17, 20]]);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onConsentComplete = function onConsentComplete(event) {
    var eventOrigin = get(event, 'origin');
    var originIsConsentApp = includes(consentAppUrl, eventOrigin);
    if (event.data.status === CONSENT_COMPLETED && originIsConsentApp) {
      onConsentSent();
    }
  };
  var onProvideAuthToken = function onProvideAuthToken(event) {
    if (event.data === 'retrieve-auth-token') {
      var authToken = extractAuthTokenFromAdapter(adapters.coreApi);
      iframeRef.current.contentWindow.postMessage({
        authToken: authToken
      }, '*');
    }
  };
  if (isConsentAppShown) {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-or-upload-consent-form consent-request-form-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "consent-app-frame"
    }, /*#__PURE__*/React.createElement(OverlaySpinner, {
      text: "Loading Web Consent Form",
      show: isConsentAppLoading
    }), consentAppUrl && /*#__PURE__*/React.createElement(ConsentAppFrame, {
      consentAppUrl: consentAppUrl,
      onBackClick: function onBackClick() {
        return onCurrentViewChange('initial');
      },
      onSetRef: function onSetRef(element) {
        iframeRef.current = element;
      },
      onLoad: function onLoad() {
        return setIsConsentAppLoading(false);
      }
    })));
  }
  var email_address = contact && findPrimaryOrFirst(contact.email_addresses).email_address;
  var phone_number = contact && findPrimaryOrFirst(contact.phone_numbers).phone_number;
  var initialValues = {
    email_address: email_address || '',
    phone_number: phone_number || ''
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: initialValues
  }, function (formProps) {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-or-upload-consent-form consent-request-form-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "consent-request-form content-with-actions"
    }, /*#__PURE__*/React.createElement(OverlaySpinner, {
      text: getSubmitConsentText(selectedConsentType),
      show: submitting
    }), /*#__PURE__*/React.createElement("p", {
      className: "mx-2 container-text-block"
    }, CONSENT_FORM_HEADER_MESSAGE), /*#__PURE__*/React.createElement("div", {
      className: "mx-2 mt-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "pb-4 preferred-language-message"
    }, CHOOSE_PREFERRED_LANGUAGE_MESSAGE), /*#__PURE__*/React.createElement(LanguageSelector, {
      onChange: onLanguageChange,
      field: {
        name: CONSENT_OPTIONS.LANGUAGE,
        value: language
      },
      disabled: !includes(DIGITAL_CONSENT_TYPES, selectedConsentType),
      translationsNewLanguageFlag: shouldShowTranslationsNewLanguages
    })), /*#__PURE__*/React.createElement(ConsentTypeChoices, {
      onSubmit: formProps.handleSubmit,
      selectConsentType: function selectConsentType(selectedConsentType) {
        return setSelectedConsentType(selectedConsentType);
      },
      selectedConsentType: selectedConsentType,
      showConsent: function showConsent(_ref2) {
        var isConsentAttestation = _ref2.isConsentAttestation;
        return onCurrentViewChange(isConsentAttestation ? 'consentAppAttestation' : 'consentApp');
      },
      downloadConsentUrl: constants.CONSENT_DOWNLOAD_URL,
      verbalScriptUrl: constants.VERBAL_CONSENT_SCRIPT_URL,
      fileUpload: fileUpload,
      onFileUpload: function onFileUpload(fileUpload) {
        return setFileUpload(fileUpload);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-right footer-actions actions"
    }, /*#__PURE__*/React.createElement(Button, {
      id: "skip-consent-btn",
      className: "px-3 normal-case skip-consent-btn text-action-blue border-border-grey",
      label: "Skip for now",
      onClick: onNavigateAway,
      shouldRender: allowSkipConsent
    }), isUploadConsentType(selectedConsentType) ? /*#__PURE__*/React.createElement("span", {
      className: "action-item"
    }, /*#__PURE__*/React.createElement(Button, {
      id: "audio-document-consent-btn",
      className: "document-or-audio-consent-submit-btn",
      disabled: submitting,
      label: "Submit",
      onClick: formProps.handleSubmit,
      style: styles.submitButton,
      primary: true
    })) : null)));
  });
}
RequestOrUploadConsentForm.propTypes = {
  allowSkipConsent: PropTypes.bool,
  contact: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  currentView: PropTypes.string.isRequired,
  initialConsentType: PropTypes.string,
  styles: PropTypes.shape({
    submitButton: PropTypes.object
  }),
  language: PropTypes.string.isRequired,
  callbacks: PropTypes.shape({
    onLanguageChange: PropTypes.func.isRequired,
    onCommunicationSent: PropTypes.func.isRequired,
    onConsentSent: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onCurrentViewChange: PropTypes.func.isRequired,
    onNavigateAway: PropTypes.func.isRequired,
    onTrackEvent: PropTypes.func.isRequired
  }).isRequired,
  adapters: PropTypes.shape({
    coreApi: PropTypes.object.isRequired
  }).isRequired,
  constants: PropTypes.shape({
    CONSENT_APP_URL: PropTypes.string.isRequired,
    CONSENT_DOWNLOAD_URL: PropTypes.string,
    VERBAL_CONSENT_SCRIPT_URL: PropTypes.string
  }).isRequired,
  flags: PropTypes.shape({
    shouldShowTranslationsNewLanguages: PropTypes.bool.isRequired
  }).isRequired
};
RequestOrUploadConsentForm.defaultProps = {
  allowSkipConsent: false,
  styles: {
    submitButton: {
      marginLeft: '20px'
    }
  }
};
//# sourceMappingURL=index.js.map